import { render } from "./InspectionTypeUpdateForm.vue?vue&type=template&id=1b4f5dab"
import script from "./InspectionTypeUpdateForm.vue?vue&type=script&lang=js"
export * from "./InspectionTypeUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__